<p (click)="goToOrder()" *ngIf="order && active" class="ion-margin" expand="block">
	{{ 'menu_page.order_btn' | translate }}
	<span class="vertical-line"></span>
	{{ formattedPrice }}
</p>
